import { proctoringUBALogger } from '../../../utils/trackingUtil';
import { SECURE_BROWSER_CONST } from '../../../constants/Constants';

export default function exitSecureBrowserApplication({ onDone } = {}) {
  try {
    if (window?.electron?.sendMsgToElectron) {
      const { sendMsgToElectron } = window.electron;
      sendMsgToElectron('EXIT_TEST', '{}', () => {
        proctoringUBALogger(
          SECURE_BROWSER_CONST.LOG_INFO_EVENT,
          'exited-assessment'
        );
        if (typeof onDone === 'function') onDone();
      });
    }
  } catch (err) {
    proctoringUBALogger(SECURE_BROWSER_CONST.LOG_INFO_ERR, err?.message);
    if (typeof onDone === 'function') onDone(err);
  }
}
